// PartA5.js - Part A5 Accomplishments Inventory component (Single Page)
import React, { useState, useEffect } from 'react';
import { Button, message } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import { getAccessToken } from '../../authClient';
import PartA5Accomplishments from './components/PartA5Accomplishments';
import { API_CONFIG } from '../../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

const PartA5 = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    // Form data state for Part A5 grid selections
    const [formData, setFormData] = useState({
        // Row 1: Have I gathered information about...
        info_entrance_exams: false,
        info_colleges_universities: false, // Note: Check key consistency with component
        info_colleges: false, // Adding both potential keys to be safe, component uses 'info_colleges'
        info_prospective_jobs: false, // Component uses 'info_job_roles'
        info_job_roles: false,

        // Row 2: Have I started preparation for...
        prep_entrance_tests: false,
        prep_college_forms: false, // Component uses 'prep_forms'
        prep_forms: false,
        prep_portfolio: false,

        // Row 3: Have I acquired academic skills like...
        skill_critical_thinking: false, // Component uses 'skill_academic_thinking'
        skill_academic_thinking: false,
        skill_collaboration: false, // Component uses 'skill_academic_collaborating'
        skill_academic_collaborating: false,
        skill_independent_work: false, // Component uses 'skill_academic_research'
        skill_academic_research: false,
        skill_technology: false, // Component uses 'skill_academic_tech'
        skill_academic_tech: false,
        skill_follow_directions: false, // Component uses 'skill_academic_directions'
        skill_academic_directions: false,
        skill_time_management: false, // Component uses 'skill_academic_time'
        skill_academic_time: false,

        // Row 4: Life Skills
        skill_money_budgeting: false, // Component uses 'skill_life_money'
        skill_life_money: false,
        skill_stress_management: false, // Component uses 'skill_life_stress'
        skill_life_stress: false,
        skill_safety_awareness: false, // Component uses 'skill_life_safety'
        skill_life_safety: false,
        skill_holistic_selfcare: false, // Component uses 'skill_life_selfcare'
        skill_life_selfcare: false,
        skill_integrity: false, // Component uses 'skill_life_integrity'
        skill_life_integrity: false,
        skill_help_seeking: false, // Component uses 'skill_life_help'
        skill_life_help: false,

        // Row 5: Personal Qualities
        quality_respect_tolerance: false, // Component uses 'quality_respect'
        quality_respect: false,
        quality_empathy: false,
        quality_resilience: false,
        quality_citizenship: false,
        quality_sustainability: false,
        quality_social_concern: false, // Component uses 'quality_society'
        quality_society: false
    });

    useEffect(() => {
        loadExistingData();
    }, []);

    const loadExistingData = async () => {
        try {
            const token = getAccessToken();
            const response = await fetch(`${API_BASE_URL}/secondary/user/hpc-profile/part-a5`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.exists && data.part_a_5) {
                    setFormData(prevData => ({
                        ...prevData,
                        ...data.part_a_5
                    }));
                }
            }
        } catch (error) {
            console.error('Error loading existing data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (key, value) => {
        setFormData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const token = getAccessToken();
            const response = await fetch(`${API_BASE_URL}/secondary/user/hpc-profile/part-a5`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                message.success('Part A5 saved successfully!');
            } else {
                throw new Error('Failed to save Part A5');
            }
        } catch (error) {
            console.error('Error saving Part A5:', error);
            message.error('Failed to save Part A5');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="w-full">
            <PartA5Accomplishments
                formData={formData}
                handleInputChange={handleInputChange}
            />

            {/* Save Controls */}
            <div className="flex justify-center gap-4 mt-8 mb-12">
                <Button
                    type="primary"
                    size="large"
                    icon={<SaveOutlined />}
                    onClick={handleSave}
                    loading={saving}
                    className="bg-blue-600 hover:bg-blue-500"
                >
                    {saving ? 'Saving...' : 'Save Part A5'}
                </Button>
                <Button
                    size="large"
                    icon={<ReloadOutlined />}
                    onClick={loadExistingData}
                >
                    Reload Data
                </Button>
            </div>
        </div>
    );
};

export default PartA5;